var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "门店",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("store-tenant-select", {
                                    attrs: { domain: "stock" },
                                    on: { change: _vm.handleStoreTenantChange },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "商品信息",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder:
                                        "请输入条码、名称、助记码、规格、型号等信息",
                                    },
                                    model: {
                                      value: _vm.queryParam.materialParam,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "materialParam",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.materialParam",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "单据日期",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-range-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      format: "YYYY-MM-DD",
                                      placeholder: ["开始时间", "结束时间"],
                                    },
                                    on: { change: _vm.onDateChange },
                                    model: {
                                      value: _vm.queryParam.createTimeRange,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "createTimeRange",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.createTimeRange",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("a-col", { attrs: { md: 6, sm: 24 } }, [
                            _c(
                              "span",
                              {
                                staticClass: "table-page-search-submitButtons",
                                staticStyle: {
                                  float: "left",
                                  overflow: "hidden",
                                },
                              },
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.searchQuery },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    directives: [
                                      {
                                        name: "print",
                                        rawName: "v-print",
                                        value: "#reportPrint",
                                        expression: "'#reportPrint'",
                                      },
                                    ],
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "printer" },
                                  },
                                  [_vm._v("打印")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "download" },
                                    on: { click: _vm.exportExcel },
                                  },
                                  [_vm._v("导出")]
                                ),
                                _c(
                                  "a",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    on: { click: _vm.handleToggleSearch },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.toggleSearchStatus
                                            ? "收起"
                                            : "展开"
                                        ) +
                                        "\n                  "
                                    ),
                                    _c("a-icon", {
                                      attrs: {
                                        type: _vm.toggleSearchStatus
                                          ? "up"
                                          : "down",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c("a-form-item", [
                                _c("span", [
                                  _vm._v(
                                    "总数量：" +
                                      _vm._s(_vm.operNumberTotalStr) +
                                      "，总金额：" +
                                      _vm._s(_vm.allPriceTotalStr)
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.toggleSearchStatus
                        ? [
                            _c(
                              "a-row",
                              { attrs: { gutter: 24 } },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "单据编号",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder: "请输入单据编号",
                                          },
                                          model: {
                                            value: _vm.queryParam.number,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "number",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.number",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "往来单位",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择往来单位",
                                              dropdownMatchSelectWidth: false,
                                              showSearch: "",
                                              "allow-clear": "",
                                              optionFilterProp: "children",
                                            },
                                            on: {
                                              search: _vm.handleSearchOrgan,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "dropdownRender",
                                                  fn: function (menu) {
                                                    return _c(
                                                      "div",
                                                      {},
                                                      [
                                                        _c("v-nodes", {
                                                          attrs: {
                                                            vnodes: menu,
                                                          },
                                                        }),
                                                        _c("a-divider", {
                                                          staticStyle: {
                                                            margin: "4px 0",
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "dropdown-btn",
                                                            on: {
                                                              mousedown: (e) =>
                                                                e.preventDefault(),
                                                              click:
                                                                _vm.initOrgan,
                                                            },
                                                          },
                                                          [
                                                            _c("a-icon", {
                                                              attrs: {
                                                                type: "reload",
                                                              },
                                                            }),
                                                            _vm._v(" 刷新列表"),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              957342900
                                            ),
                                            model: {
                                              value: _vm.queryParam.organId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "organId",
                                                  $$v
                                                )
                                              },
                                              expression: "queryParam.organId",
                                            },
                                          },
                                          _vm._l(
                                            _vm.organList,
                                            function (item, index) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: index,
                                                  attrs: { value: item.id },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.supplier) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "仓库",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              optionFilterProp: "children",
                                              dropdownMatchSelectWidth: false,
                                              showSearch: "",
                                              "allow-clear": "",
                                              placeholder: "请选择仓库",
                                            },
                                            model: {
                                              value: _vm.queryParam.depotId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "depotId",
                                                  $$v
                                                )
                                              },
                                              expression: "queryParam.depotId",
                                            },
                                          },
                                          _vm._l(
                                            _vm.depotList,
                                            function (depot, index) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: index,
                                                  attrs: { value: depot.id },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(depot.depotName) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "操作员",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择操作员",
                                              showSearch: "",
                                              "allow-clear": "",
                                              optionFilterProp: "children",
                                            },
                                            model: {
                                              value: _vm.queryParam.creator,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "creator",
                                                  $$v
                                                )
                                              },
                                              expression: "queryParam.creator",
                                            },
                                          },
                                          _vm._l(
                                            _vm.userList,
                                            function (item, index) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: index,
                                                  attrs: { value: item.id },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.userName) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.orgaTree.length
                                  ? _c(
                                      "a-col",
                                      { attrs: { md: 6, sm: 24 } },
                                      [
                                        _c(
                                          "a-form-item",
                                          {
                                            attrs: {
                                              label: "部门",
                                              labelCol: _vm.labelCol,
                                              wrapperCol: _vm.wrapperCol,
                                            },
                                          },
                                          [
                                            _c("a-tree-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                "allow-clear": "",
                                                treeData: _vm.orgaTree,
                                                placeholder: "请选择部门",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryParam.organizationId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryParam,
                                                    "organizationId",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryParam.organizationId",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "商品类别",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-tree-select", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            dropdownStyle: {
                                              maxHeight: "200px",
                                              overflow: "auto",
                                            },
                                            "allow-clear": "",
                                            treeData: _vm.categoryTree,
                                            placeholder: "请选择商品类别",
                                          },
                                          model: {
                                            value: _vm.queryParam.categoryId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "categoryId",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.categoryId",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "备注",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: { placeholder: "请输入备注" },
                                          model: {
                                            value: _vm.queryParam.remark,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "remark",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.remark",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "section",
                { ref: "print", attrs: { id: "reportPrint" } },
                [
                  _c(
                    "a-table",
                    {
                      ref: "table",
                      attrs: {
                        bordered: "",
                        size: "middle",
                        rowKey: "id",
                        columns: _vm.columns,
                        dataSource: _vm.dataSource,
                        components: _vm.handleDrag(_vm.columns),
                        pagination: false,
                        scroll: _vm.scroll,
                        loading: _vm.loading,
                      },
                      on: { change: _vm.handleTableChange },
                      scopedSlots: _vm._u([
                        {
                          key: "numberCustomRender",
                          fn: function (text, record) {
                            return _c("span", {}, [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.myHandleDetail(record)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(record.number))]
                              ),
                            ])
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "customTitle" }, slot: "customTitle" },
                        [
                          _c(
                            "a-popover",
                            { attrs: { trigger: "click", placement: "right" } },
                            [
                              _c(
                                "template",
                                { slot: "content" },
                                [
                                  _c(
                                    "a-checkbox-group",
                                    {
                                      attrs: {
                                        defaultValue: _vm.settingDataIndex,
                                      },
                                      on: { change: _vm.onColChange },
                                      model: {
                                        value: _vm.settingDataIndex,
                                        callback: function ($$v) {
                                          _vm.settingDataIndex = $$v
                                        },
                                        expression: "settingDataIndex",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-row",
                                        { staticStyle: { width: "600px" } },
                                        [
                                          _vm._l(
                                            _vm.defColumns,
                                            function (item, index) {
                                              return [
                                                [
                                                  _c(
                                                    "a-col",
                                                    { attrs: { span: 6 } },
                                                    [
                                                      item.dataIndex ===
                                                      "rowIndex"
                                                        ? _c("a-checkbox", {
                                                            attrs: {
                                                              value:
                                                                item.dataIndex,
                                                              disabled: "",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      item.dataIndex !==
                                                      "rowIndex"
                                                        ? _c(
                                                            "a-checkbox",
                                                            {
                                                              attrs: {
                                                                value:
                                                                  item.dataIndex,
                                                              },
                                                            },
                                                            [
                                                              _c("j-ellipsis", {
                                                                attrs: {
                                                                  value:
                                                                    item.title,
                                                                  length: 10,
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      _c(
                                        "a-row",
                                        {
                                          staticStyle: {
                                            "padding-top": "10px",
                                          },
                                        },
                                        [
                                          _c(
                                            "a-col",
                                            [
                                              _vm._v(
                                                "\n                      恢复默认列配置："
                                              ),
                                              _c(
                                                "a-button",
                                                {
                                                  attrs: {
                                                    type: "link",
                                                    size: "small",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.handleRestDefault,
                                                  },
                                                },
                                                [_vm._v("恢复默认")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("a-icon", { attrs: { type: "setting" } }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "a-row",
                    {
                      staticStyle: {
                        "margin-top": "8px",
                        "text-align": "right",
                      },
                      attrs: { gutter: 24 },
                    },
                    [
                      _c(
                        "a-col",
                        { attrs: { md: 24, sm: 24 } },
                        [
                          _c("a-pagination", {
                            attrs: {
                              size: "small",
                              "show-size-changer": "",
                              showQuickJumper: true,
                              current: _vm.ipagination.current,
                              "page-size": _vm.ipagination.pageSize,
                              "page-size-options":
                                _vm.ipagination.pageSizeOptions,
                              total: _vm.ipagination.total,
                              "show-total": (total, range) =>
                                `共 ${
                                  total -
                                  Math.ceil(total / _vm.ipagination.pageSize)
                                } 条`,
                            },
                            on: {
                              change: _vm.paginationChange,
                              showSizeChange: _vm.paginationShowSizeChange,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "buildOptionText",
                                fn: function (props) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(props.value - 1) + "条/页"),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("bill-detail", { ref: "modalDetail" }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }